export const displayType = Object.freeze({
    link: 'Link',
    input: 'String',
    number: 'Number',
    datePicker: 'Date',
    checkBox: 'Checkbox',
    multiplechoices: 'Multiple choices'
})